// extracted by mini-css-extract-plugin
export default {"filter":"QuestionList_filter__GEwBt","fadeIn":"QuestionList_fadeIn__BBwu3","tblheader":"QuestionList_tblheader__u84cT","btn":"QuestionList_btn__stC7E"};